import { fruitGroupsIdNameQuery } from "types/agriculture/sale-types";
import { InputCostumeErrorType } from "types/form-types";
import FruitClassificationMultiselectInput, { ClassificationType, FruitClassificationMultiselectInputPropsType } from "./FruitClassificationMultiselectInput";

type FruitGroupMultiselectInputPropsType = {
    fruitId: string | undefined | null | number | false,
    value?: ClassificationType[],
    onChange?: (s: ClassificationType[] | undefined, event: React.MouseEvent | React.KeyboardEvent | React.FocusEvent) => void,
    min?: number,
    max?: number,
    customErrors?: InputCostumeErrorType<ClassificationType[], HTMLInputElement>[],
    required?: boolean
    name?: string
    label?: string
}

const FruitGroupMultiselectInput = (props: FruitGroupMultiselectInputPropsType) => {
    const fruitGroupsMultiSelectSettings: FruitClassificationMultiselectInputPropsType = {
        fruitId: props.fruitId,
        queryData: {
            query: fruitGroupsIdNameQuery,
            field: "fruitGroups"
        },
        label: props.label || 'fields.group.name',
        name: props.name || "fruitGroup",
        onChange: props.onChange,
        customErrors: props.customErrors,
        max: props.max,
        min: props.min,
        required: props.required
    }

    return (
        <FruitClassificationMultiselectInput
            {...fruitGroupsMultiSelectSettings}
            value={props.value}
        />
    );
};

export default FruitGroupMultiselectInput;
